<form (submit)="onSubmit($event)">
  <dx-form [formData]="formData" [disabled]="loading">

    <dxi-form-item dataField="password" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Password', mode: 'password' }">
      <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule>
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item dataField="confirmedPassword" editorType="dxTextBox"
      [editorOptions]="{ stylingMode: 'filled', placeholder: 'Confirm Password', mode: 'password' }">
      <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule>
      <dxi-form-validation-rule type="custom" message="Passwords do not match" [validationCallback]="confirmPassword">
      </dxi-form-validation-rule>
      <dxo-form-label [visible]="false"></dxo-form-label>
    </dxi-form-item>

    <dxi-form-item itemType="button">
      <dxo-form-button-options width="100%" type="default" [useSubmitBehavior]="true" [template]="'changePasswordTemplate'">
      </dxo-form-button-options>
    </dxi-form-item>

    <ng-container *dxTemplate="let item of 'changePasswordTemplate'">
      <div>
        <span class="dx-button-text">
          <ng-container *ngIf="loading; else notLoading">
            <dx-load-indicator width="24px" height="24px" [visible]="true"></dx-load-indicator>
          </ng-container>
          <ng-template #notLoading>Continue</ng-template>
        </span>
      </div>
    </ng-container>

  </dx-form>
</form>
